import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { reduce, isArray, has } from "lodash";
import { environment } from '../../../environments/environment'
import { orderBy, omit } from "lodash";
import * as dayjs from "dayjs";

declare var google: any;
declare var window:any;

@Injectable({
  providedIn: "root",
})
export class UtilsService {

  constructor(private http: HttpClient) {}

  getApi() {
    return environment.API_BASE_URL 
  }

  makeRequest(
    url,
    type: RequestType = RequestType.get,
    data = undefined,
    options = undefined
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!options) {
        options = {};
      }
      if (!options.headers) {
        options.headers = {};
      }
      options.headers["Strapi-Response-Format"] = "v4";
      
      let request;
      if (type== RequestType.get) request = this.http.get(`${this.getApi()}/${url.trim()}`, options);
      else if (options && type == RequestType.post) { request = this.http['post'](`${this.getApi()}/${url.trim()}`, data, options);}
      else request = this.http[type](`${this.getApi()}/${url.trim()}`, data);

      request.subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {
          console.log("There was an Error", error);
          reject(error);
        }
      );
    });
  }

  makeGetRequest(url) {
    return this.makeRequest(url, RequestType.get);
  }

  makeUploadRequest(url: string, body: FormData, options: any = {}) {
    const headers = options.headers || {};
    console.log('FormData:', body.get('files')); // Debugging: Log the file being sent
    return this.http.post(`${this.getApi()}/${url.trim()}`, body, {
      headers: {
        ...headers, // Include any additional headers (e.g., Authorization)
      },
    });
  }

  makePostRequest(url, data = null, options = null) {
    return this.makeRequest(url, RequestType.post, {data: prepEntityForUpload(data)}, options);
  }


  makePutRequest(url, data = null) {
    return this.makeRequest(url, RequestType.put, {data: prepEntityForUpload(data)});
  }

  makePatchRequest(url, data = null) {
    return this.makeRequest(url, RequestType.patch, {data: prepEntityForUpload(data)});
  }

  makeDeleteRequest(url) {
    return this.makeRequest(url, RequestType.delete);
  }
}

export function getSecoundsBetweenDates(from, to){
  from = new Date(from);
  to = new Date(to);
  return Number(((to-from)/1000).toFixed(0))
}

export function getDaysFromToday(date){
  return dayjs(new Date()).diff(date, 'day',false)
}

export function orderbyNearestDate(list, dateProperty){
  return orderBy(list, [(item) => {
    return dayjs(item[dateProperty]).format('YYYY-MM-DD')
 }], ['desc'])
}

export enum RequestType {
  get = "get",
  post = "post",
  put = "put",
  patch = "patch",
  delete = "delete",
}

function prepEntityForUpload(entity){
  entity = omit(entity, ['id', 'createdAt', 'updatedAt', 'circleName', 'name', 'documentId']);
  return entity;
}